  <template>
    <div class="stub-container" @click="emit('click')">
      <img src="/lock.png" alt="lock" class="stub-icon" />
      <p class="stub-text">{{ text }}</p>
    </div>
  </template>
  
  <script setup>
  const props = defineProps({
    text: {
      type: String,
      required: true,
    },
  });
  
  const emit = defineEmits(["click"]);
  </script>
  
  <style scoped>
  .stub-container {
    width: 270px;
    height: 150px;
    background-color: #e5e5e5;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 16px;
    text-align: center;
    border: 1px solid rgba(0, 0, 0, 0.05);
  }

  [data-theme="dark"] .stub-container {
  background-color: #2a2a2a;
  border: 1px solid rgba(255, 255, 255, 0.08);
}
  
  .stub-icon {
    width: 28px;
    height: 28px;
    opacity: 0.6;
  }
  
  .stub-text {
    font-size: 11px;
    font-family: "Eastman-Regular", sans-serif;
    color: #9e9e9e;
    margin: 0;
  }
  
  [data-theme="dark"] .stub-container {
    background-color: #1e1e1e;
  }
  
  [data-theme="dark"] .stub-text {
    color: #bdbdbd;
  }
  
  [data-theme="dark"] .stub-icon {
    filter: brightness(0.8);
    opacity: 0.7;
  }

  .stub-container {
  cursor: pointer;
  transition: all 0.25s ease;
}

.stub-container:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
}

[data-theme="dark"] .stub-container:hover {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
}

@media (max-width: 430px) {
.stub-container {
  width: 100%;
  box-sizing: border-box;
}
}

  </style>